import { apiSlice } from "../apiSlice";

interface GetUserInfoResponse {
  userId: string;
  displayName: string;
  email: string;
  phoneNumber: string;
  userRoles: string[];
  photoUrl?: string | null;
}
const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PRODUCTION;
export const getUserService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getExistingUserInfo: builder.query<GetUserInfoResponse, string>({
      query: (accessToken) => ({
        url: `https://userhttps-getexistinguserinfo-${API_BASE_DOMAIN}-uc.a.run.app`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`, 
        },
      }),
    }),
  }),
});


export const {  useLazyGetExistingUserInfoQuery } = getUserService;
